import type { IntroCardHow } from "./introCardStatus";

/**
 * Every fixed label the collapsible intro cards add (D2–D10, J3–J9), in one
 * place so the tests pin the words the consultant reads. The messages
 * themselves — and every sentence the cards showed before — are unchanged
 * (D11) and live where they always did.
 */
export const introCardCopy = {
  notDrafted: "Not drafted",
  draftSaved: "Draft saved",
  /** J3 — the two email cards (RECORD SEND). */
  copiedNotRecorded: "Copied — not recorded",
  /** J3 — the text, follow-up text and web form (LOG / I SUBMITTED IT). */
  copiedNotLogged: "Copied — not logged",
  sent: (date: string, how: IntroCardHow | null) => `Sent ${date}${how ? ` · ${how}` : ""}`,
  logged: (date: string) => `Logged ${date}`,

  /** J8 — the one control that reveals a sent card's editor, on every card. */
  editAndSendAgain: "Edit and send again",
  showFullMessage: "Show full message",
  showLess: "Show less",
  viewFullEmail: "View full email",
  hideFullEmail: "Hide full email",
  whatWentOut: "What went out",

  expandAll: "Expand all",
  collapseAll: "Collapse all",
  sendHistory: (n: number) => `Send history (${n})`,

  /** D10 — the small link that replaces the empty state once a send exists. */
  draftSeparateIntro: "Draft a separate intro email for this listing",

  /** D9 / J4 — this listing's part of a combined intro. */
  sentAsPartOf: (name: string, count: number, date: string) =>
    `Sent as part of one email to ${name} covering ${count} listings on ${date}.`,
} as const;
